var React = require('react');

function Divider4 (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#ffffff","points":"100 0 100 100 0 100"}));
}

Divider4.defaultProps = {"width":"100%","height":"96px","viewBox":"0 0 100 100","version":"1.1","preserveAspectRatio":"none"};

module.exports = Divider4;

Divider4.default = Divider4;
